module.exports = __webpack_public_path__ + "img/flex-align-bottom.6bb020d9.svg";